module.exports = __webpack_public_path__ + "static/IgorHristovCV-73a3457224d534e7c7f85d82262c6c3d.pdf";